import { TextFieldV2 } from '@fdha/web-ui-library';
import { NumberQuestionProps } from '@models';
import { useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { FC } from 'react';

interface NumberViewProps {
  question: NumberQuestionProps;
  handleChange: (value: any, name?: string) => void;
}

interface Context {
  [key: string]: string;
}

export const NumberView: FC<NumberViewProps> = ({ question, handleChange }) => {
  const { values, handleBlur, errors, touched } = useFormikContext<Context>();

  const theme = useTheme();

  const key = question.id;
  const error = touched[key] ? errors[key] : '';

  return (
    <TextFieldV2
      type="number"
      name={key}
      value={values[key]}
      placeholder={question.placeholder}
      onChange={(event) => handleChange(event.target.value)}
      onBlur={handleBlur}
      error={!!error}
      helperText={error}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: '10px',
      }}
    />
  );
};
